import { ArrowRight, Check } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Pricing = () => {
  const { t } = useLang();
  const benefits = [
    "PDF upload & data extraction",
    "Party-wise debtor/creditor view",
    "Payment & collection reminders",
    "Team roles (up to 5 members)",
    "Owner-only settings",
    "Free demo & onboarding",
  ];

  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-20 lg:py-28 border-t border-stone-200"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-mono-label text-stone-500">{t.pricing.eyebrow}</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">
            {t.pricing.title}
          </h2>
          <p className="mt-5 text-lg text-stone-600 leading-relaxed">
            {t.pricing.subtitle}
          </p>
        </div>

        <div className="mt-12 bg-green-900 text-stone-50 rounded-3xl p-10 lg:p-14 relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-56 h-56 rounded-full bg-stone-50/10 blur-3xl" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center relative">
            <div>
              <p className="font-mono-label text-stone-300">EVERYTHING INCLUDED</p>
              <h3 className="font-display mt-3 text-3xl sm:text-4xl text-stone-50">
                One simple plan. Tailored to your shop.
              </h3>
              <a
                href="#contact"
                data-testid="pricing-cta"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-stone-50 text-green-900 font-semibold hover:bg-white transition-colors"
              >
                {t.pricing.cta}
                <ArrowRight size={18} />
              </a>
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-2 text-stone-100">
                  <Check size={18} className="text-stone-50 mt-0.5 shrink-0" />
                  <span className="text-sm">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
